import React from "react";
import PropTypes from "prop-types";
import AddCapsuleClassButton from "./AddCapsuleClassButton/AddCapsuleClassButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CLASS_CREATE_PERMISSION } from "../../permissions";
import "./CapsuleClassesHeader.scss";

const CapsuleClassesHeader = ({
    numberOfClasses,
    handleCapsulationSuccess,
    hideAddClassBtn,
}) => {
    return (
        <>
            <div className='capsule__class--header'>
                <h3 className='capsule__class--header--text'>
                    Classes{" "}
                    <span className='capsule__class--header--badge'>
                        {numberOfClasses}
                    </span>
                </h3>
                {!hideAddClassBtn && (
                    <ComponentAccessControl baseResources={CLASS_CREATE_PERMISSION}>
                        <AddCapsuleClassButton
                            handleCapsulationSuccess={handleCapsulationSuccess}
                        />
                    </ComponentAccessControl>
                )}
            </div>
        </>
    );
};

CapsuleClassesHeader.prototypes = {
    handleSuccess: PropTypes.func.isRequired,
    numberOfClasses: PropTypes.oneOfType([
        PropTypes.number.isRequired,
        PropTypes.bool,
    ]).isRequired,
};

export default CapsuleClassesHeader;
